import { render, staticRenderFns } from "./delivery-pickup-tab.vue?vue&type=template&id=a5226088&"
import script from "./delivery-pickup-tab.vue?vue&type=script&lang=js&"
export * from "./delivery-pickup-tab.vue?vue&type=script&lang=js&"
import style0 from "./delivery-pickup-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5226088')) {
      api.createRecord('a5226088', component.options)
    } else {
      api.reload('a5226088', component.options)
    }
    module.hot.accept("./delivery-pickup-tab.vue?vue&type=template&id=a5226088&", function () {
      api.rerender('a5226088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/delivery-pickup-tab.vue"
export default component.exports